export const additionalQuestions = [
  {
    question: 'How did you hear about us?',
    name: 'hearAboutUs',
    options: [
      {
        key: 'direct',
        name: 'Direct mail',
        additionalField: '',
      },
      {
        key: 'email',
        name: 'Email',
        additionalField: '',
      },
      {
        key: 'facebook',
        name: 'Facebook',
        additionalField: '',
      },
      {
        key: 'instagram',
        name: 'Instagram',
        additionalField: '',
      },
      {
        key: 'x',
        name: 'X',
        additionalField: '',
      },
      {
        key: 'engine',
        name: 'Search engine (Google, Bing)',
        additionalField: '',
      },
      {
        key: 'referral',
        name: 'Referral',
        additionalField: "The name of the referral",
      },
      {
        key: 'other',
        name: 'other',
        additionalField: '',
      }
    ]
  }
]
